module.exports = __webpack_public_path__ + "static/logo_icf-f4db1af3c376a4cb517ded699f924950.png";